module.exports = __webpack_public_path__ + "static/img/logo.f44ca1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/img/logo.png
// module id = 729
// module chunks = 1